<template>
  <div :class="$style.view">
    <h1 :class="$style.view__header">
      意図しないユーザーの名前が記入されている可能性があります
    </h1>
    <div :class="[$style.view__attention, $style.attention]">
      <p :class="$style.attention__header">
        意図しないユーザーの名前が記入されており、アプローチの誤送信になる可能性があります。<br />
        {{
          REPLACE_NAME_VARIABLES.name
        }}と記述すると自動でユーザー名に変換されます。
      </p>
      <ul :class="$style.attention__list">
        <li v-for="(name, index) in maybeUserNames" :key="index">
          ・{{ name }}
        </li>
      </ul>
    </div>
    <FlatButton
      :class="$style.view__postButton"
      variant="primary"
      size="medium"
      @click="emit('submit')"
    >
      この内容で保存する
    </FlatButton>
    <FlatButton
      :class="$style.view__editButton"
      variant="secondary"
      size="medium"
      @click="emit('cancel')"
    >
      修正する
    </FlatButton>
  </div>
</template>

<script setup lang="ts">
import FlatButton from '@/components/atoms/FlatButton.vue'
import { REPLACE_NAME_VARIABLES } from '@/libs/utilities/replaceVariable'

defineProps<{ maybeUserNames: string[] }>()

const emit = defineEmits<{
  (event: 'submit'): void
  (event: 'cancel'): void
}>()
</script>

<style lang="scss" module>
.view {
  display: flex;
  min-width: 400px;
  flex-basis: 800px;
  flex-direction: column;
  align-items: center;
  padding: 30px;

  &__header {
    color: $color-text-and-object-high-emphasis;
    font-size: 24px;
    font-weight: bold;
    line-height: 40px;
  }

  &__attention {
    &:nth-child(n + 2) {
      margin-top: 24px;
    }
  }

  &__description {
    color: $color-text-and-object-high-emphasis;
    font-size: 14px;
    line-height: 24px;

    &:nth-child(n + 2) {
      margin-top: 16px;
    }
  }

  &__comment {
    width: 100%;
    padding: 16px 24px;

    &:nth-child(n + 2) {
      margin-top: 24px;
    }
  }

  &__postButton {
    width: 240px;

    &:nth-child(n + 2) {
      margin-top: 24px;
    }
  }

  &__editButton {
    width: 240px;

    &:nth-child(n + 2) {
      margin-top: 8px;
    }
  }
}

.attention {
  color: $color-caution-accent;
  font-size: 14px;

  &__header {
    font-weight: bold;
  }

  &__list {
    &:nth-child(n + 2) {
      margin-top: 16px;
    }
  }
}
</style>
